import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

export interface HaedInfoState {
  isBall: boolean;
}

const LOCALKEY = localKeyInfo.headInfo;
const localVoiceInfo = LocalStore.getValue<HaedInfoState>(LOCALKEY) || {};

export const haedInfo: HaedInfoState = {
  isBall: false,
  ...localVoiceInfo
};

export const setHeadInfo: (payload: HaedInfoState) => IAction<HaedInfoState> = (payload: HaedInfoState) => ({
  type: 'setHeadInfo',
  payload
});

const haedInfoReducer: Reducer<HaedInfoState, IAction<any>> = (state = haedInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setHeadInfo':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default haedInfoReducer;
